import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import React, { Fragment } from 'react';
import { Box, Heading, Text } from 'roo-ui/components';
import {
  DOMESTIC_PHONE_NUMBER,
  INTERNATIONAL_PHONE_NUMBER,
  LIVE_CHAT_OPERATING_TIMES,
  QH_FAQ_URL,
  QH_CONTACT_US_URL,
  PHONE_SUPPORT_OPERATING_TIMES,
} from 'config';

const BaseText = styled(Text)`
  font-size: ${themeGet('fontSizes.base')};
`;

const QHContactDetails = () => (
  <Fragment>
    <Heading.h2 data-print-style="h2">Need help with your booking?</Heading.h2>
    <Box borderBottom={1} borderColor="greys.alto" data-print-style="section">
      <Box mb={4}>
        <BaseText>Call our customer support: {`  `}</BaseText>
        <BaseText data-testid="domestic-phone-number" fontWeight="bold">
          {DOMESTIC_PHONE_NUMBER}
          {`  `}
        </BaseText>

        <BaseText data-testid="international-phone-number">(outside Australia: {INTERNATIONAL_PHONE_NUMBER})</BaseText>

        <BaseText data-testid="phone-opening-hours" display="block">
          Available from {PHONE_SUPPORT_OPERATING_TIMES} (Monday - Sunday)
        </BaseText>
      </Box>

      <Box mb={4}>
        <BaseText>Visit our live chat:</BaseText>
        <BaseText data-testid="live-chat-url" fontWeight="bold">
          &nbsp;&nbsp;{QH_CONTACT_US_URL}
        </BaseText>
        <BaseText data-testid="live-chat-opening-hours" display="block">
          Available between {LIVE_CHAT_OPERATING_TIMES}
        </BaseText>
      </Box>

      <Box>
        <BaseText>Read some of the frequently asked questions</BaseText>
        <BaseText data-testid="faqs-url" fontWeight="bold">
          &nbsp;&nbsp;{QH_FAQ_URL}
        </BaseText>
      </Box>
    </Box>
  </Fragment>
);

QHContactDetails.displayName = 'QHContactDetails';

export default QHContactDetails;
